<section class="publico" [class.atalhos]="modo === 'atalhos'" [class.desabilitado]="desabilitado">
  <header class="publico-topo">
    <div>
      <h4 *ngIf="modo === 'atalhos'"><i class="fe-users"></i>Campanha por segmento</h4>
      <h4 *ngIf="modo === 'seletor'"><i class="fe-users"></i>Para quem é esta campanha?</h4>
      <p *ngIf="modo === 'atalhos'">Escolha um grupo de clientes e a campanha já abre com o público e um texto sugerido.</p>
      <p *ngIf="modo === 'seletor'">Escolha um segmento do CRM: o público e um texto sugerido entram na hora. Você ainda pode usar um filtro salvo abaixo.</p>
    </div>
  </header>

  <div class="cartoes">
    <button type="button" *ngFor="let item of itensVisiveis" class="cartao"
            [class.ativo]="item.codigo === selecionado"
            [class.vazio]="carregado && !item.qtdeRecebeMensagem"
            [disabled]="desabilitado || (carregado && !item.qtdeRecebeMensagem)"
            [style.--cor]="item.cor" [style.--fundo]="item.fundo"
            [title]="item.acao"
            (click)="escolha(item)">
      <span class="icone"><i [class]="item.icone"></i></span>
      <span class="texto">
        <span class="nome">{{ item.nome }}</span>
        <span class="qtde" *ngIf="carregado">
          <strong>{{ numero(item.qtdeRecebeMensagem) }}</strong> recebem campanha
        </span>
        <span class="qtde" *ngIf="!carregado">contando…</span>
      </span>
      <i class="fe-check marcado" *ngIf="item.codigo === selecionado"></i>
      <i class="fe-arrow-right seta" *ngIf="modo === 'atalhos'"></i>
    </button>
  </div>

  <p class="dica" *ngIf="modo === 'seletor' && selecionado">
    <i class="fe-info"></i>
    Quem desativou mensagens de marketing ou está bloqueado fica fora automaticamente.
  </p>
</section>
